export default __webpack_public_path__ + "media/images/sidebar-img-01-340x220-6211088ff6329527ed4cccc53f0692eb.jpg";